import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import VueApexCharts from "vue3-apexcharts";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import './assets/theme.css';
import { vfmPlugin } from 'vue-final-modal'
import JsonExcel from "vue-json-excel3";

import setupInterceptors from './services/setupInterceptors';

setupInterceptors(store);

createApp(App).use(store).use(router).use(VueApexCharts).use(JsonExcel).use(vfmPlugin).mount('#app')
